const TermsPage = () => {
    return <div>Terms Page</div>;
};

export default TermsPage;
